
<template>
  <div class="mb-3 row">
    <div class="col">
      <div class="bg-100 shadow-none border card">
        <div class="flex-between-center row gx-0">
          <div class="d-flex align-items-center col-sm-auto">
            <h5 class="mb-0 p-3 text-primary fw-bold">
              시스템 관리<span class="text-info fw-medium" />
            </h5>
          </div>
        </div>  
      </div>     
    </div>
  </div>

  <div class="h-100 card">
    <div class="d-flex flex-between-center py-2 border-200 border-bottom card-header">
      <h6 class="mb-0">
        고객 리스트
      </h6>
    </div>
    <div class="d-flex py-2 border-200 border-bottom card-header">
      <a
        class="me-2 btn btn-falcon-default btn-sm"
        @click="handleReg"
      >
        <span
          class="mr-2 fs--2"
          data-fa-i2svg=""
        />등록
      </a>
      <a
        class="btn btn-falcon-default btn-sm"
        @click="handleUpdate"
      >
        <span
          class="mr-2"
          data-fa-i2svg=""
        />수정
      </a>
      <a
        class="btn btn-falcon-default btn-sm"
        @click="handleDelete"
      >
        <span
          class="mr-2"
          data-fa-i2svg=""
        />삭제
      </a>
    </div>
    <div class="d-flex align-items-center card-body">
      <div class="w-100">
        <CommGrid
          ref="commGridRef"
          :rows="loadResults"
          :columns="columnDefs"
          :is-check-box="true"
          :set-grid-height="null"
        />
      </div>
    </div>
  </div>

  <ClientManagerModal 
    v-if="ClientShowModal" 
    :setclient="selectClient"
    :is-reg-mode="isRegMode"
    @client-save="onClientSave"
    @client-close="ClientShowModal=false"
  />

  <AlertModal ref="alertModalRef" />
  <ConfirmModal ref="confirmRef" />
</template>

<script setup lang="ts">

import axios from 'axios'
import CommGrid from '../components/CommGrid.vue'
import '@vuepic/vue-datepicker/dist/main.css'
import { onMounted, ref} from 'vue';
import type { Client, ColumnDefinition, User } from '@/types/commontypes'
import ClientManagerModal from "@/components/ClientManagerModal.vue";
import AlertModal from "@/components/AlertModal.vue";
import ConfirmModal from "../components/ConfirmModal.vue";
import moment from 'moment';

const user = ref<User | null>(null)
const alertModalRef = ref();

const selectClient = ref<Client>({
    clientcode:'',
    clientname:'',
    clientlevel:0,
    servicestate:0,
    regdt:''
})

const columnDefs = ref<ColumnDefinition[]>([]);

const commGridRef  = ref();
const checkedRows = ref<Client[]>([]);

const loadResults = ref<Client[]>([]);
const ClientShowModal = ref(false);
const isRegMode = ref(false);

const confirmRef = ref();

onMounted(async () => {
    const res = await axios.get('/api/userinfo', { withCredentials: true });
    user.value = res.data.user;

    console.log("user info ", user);
    
    getColumnInfo();
    LoadGridData();
    // LoadClientList();
})

function formatDateTime(value: string | unknown) {
    if (!value) return '';
    return moment(value).format('YYYY-MM-DD HH:mm')
}

// 조회결과를 표시할 그리드의 컬럼정보를 구성함
function getColumnInfo() {
    const columnList: ColumnDefinition[] = [
        { field: 'clientcode', label: '고객코드', labelClass: 'vgt-center-align', thClass: 'text-center', tdClass: 'text-center'},
        { field: 'clientname', label: '고객이름', thClass: 'text-center', tdClass: 'text-center'},
        { field: 'regdt', label: '등록수정 일시', thClass: 'text-center', tdClass: 'text-center', formatFn: formatDateTime},
        { field: 'devicecount', label: '디바이스수', thClass: 'text-center', tdClass: 'text-center'},
        { field: 'servicestate', label: '상태', thClass: 'text-center', tdClass: 'text-center' , formatFn: (value: string|unknown) => {
                return value === '0' ? '종료' : '발생'
        }}
    ]

    columnDefs.value = [...columnList];
}


function LoadGridData() {
    const userjson = user.value;    
    if(!userjson)
        return;

    let clientid = "all";
	let clientlevel = 1;
	if(userjson.clientlevel == 0) {
		clientid = '';
		clientlevel = 0;
	} else {
		clientid = userjson.clientcode;
		clientlevel = 1;
	}    

    const data = JSON.stringify({ 
        'operator': "getClientDetaillist", 
        'clientcode' : clientid,
        'clientlevel' : clientlevel,
    });
   
	// content-type을 설정하고 데이터 송신
	var xhr = new XMLHttpRequest();
	xhr.open('POST', '/ajax/ajaxcall');
	xhr.setRequestHeader('Content-type', "application/json");
	xhr.send(data);

	// 데이터 수신이 완료되면 표시
	xhr.addEventListener('load', function(){
		const result : Client[] = JSON.parse(xhr.responseText);
        loadResults.value = [...result];
    });
}

/**
 * 고객등록 버튼 클릭 처리
 */
function handleReg() {
    ClientShowModal.value = true;
    isRegMode.value = true;
    selectClient.value = {
        clientcode:'',
        clientname:'',
        clientlevel:0,
        servicestate:0,
        regdt:''
    };
}

/**
 * 고객 수정 버튼 클릭 처리
 */
function handleUpdate() {
    if(!commGridRef.value) {
        return;
    }
    
    checkedRows.value = commGridRef.value.selectedRows;
    if(!checkedRows.value || checkedRows.value.length <= 0) {
        alertModalRef.value.showAlertModal("경고", "수정할 고객을 선택하세요.");
        return;
    }

    if(checkedRows.value.length > 1) {
        alertModalRef.value.showAlertModal("경고", "1개의 고객만 선택해 주세요.");
        return;
    }

    ClientShowModal.value = true;
    isRegMode.value = false;
    selectClient.value = checkedRows.value[0];
}

/**
 * 고객 삭제 버튼 처리
 */
async function handleDelete() {
    if(!commGridRef.value) {
        return;
    }
    
    checkedRows.value = commGridRef.value.selectedRows;
    if(!checkedRows.value || checkedRows.value.length <= 0) {
        alertModalRef.value.showAlertModal("경고", "삭제할 고객을 선택하세요.");
        return;
    }

    if(checkedRows.value.length > 1) {
        alertModalRef.value.showAlertModal("경고", "1개의 고객만 선택해 주세요.");
        return;
    }

    const strmsg = `선택한 고객을 삭제 하시겠습니다.`
    const ok = await confirmRef.value.showConfirmModal(
        "확인",
        strmsg
    );

    if(ok) {
        const selClient = checkedRows.value[0];

        const data = { 'operator': "deleteClient", 
                "clientcode": selClient.clientcode }
        const data2 = JSON.stringify(data)
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/ajax/ajaxcall');
        xhr.setRequestHeader('Content-type', "application/json");
        xhr.send(data2);

        // 데이터 수신이 완료되면 표시
        xhr.addEventListener('load', () => {
            const result = xhr.responseText;
            const retJSON = JSON.parse(result);
            if(retJSON.err == 0) {
                alertModalRef.value.showAlertModal("경고", `고객이 삭제 되었습니다.`);
                LoadGridData();
            } else {
                console.log("failed! ", retJSON.err);
                alertModalRef.value.showAlertModal("경고", `고객삭제가 실패 했습니다. ${retJSON.err}`);
            }
        });
    }
}

/**
 * 고객등록,수정 팝업에서 정상 저장처리후 처리 작업
 */
function onClientSave() {
    ClientShowModal.value = false;
    LoadGridData();
}

</script>

<style lang="">

</style>